import { Component, effect, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Store } from '@ngrx/store';
import { selectCompetitions } from '../../../store/selectors/competitions.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectSports } from '../../../store/selectors/sport.selectors';
import { DropdownModule } from 'primeng/dropdown';
import { selectTeams } from '../../../store/selectors/teams.selectors';
import { TextareaModule } from 'primeng/textarea';
import { createPrediction } from '../../../store/actions/prediction.actions';
import { selectCreateSuccess } from '../../../store/selectors/prediction.selectors';
import { ManagePredictionsTableComponent } from "./manage-predictions-table/manage-predictions-table.component";
import { PredictionFormComponent } from './prediction-form/prediction-form.component';


@Component({
  selector: 'app-manage-predictions',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule, DropdownModule, TextareaModule,
    ManagePredictionsTableComponent,
    PredictionFormComponent
  ],
  templateUrl: './manage-predictions.component.html',
  styleUrls: ['./manage-predictions.component.scss']
})
export class ManagePredictionsComponent implements OnInit {
  private store = inject(Store);
  customErrors = {
    dateError: false,
    isEqualTeams: false
  };


  predictionForm!: FormGroup;
  predictionResult: string | null = null;
  competitions = toSignal(this.store.select(selectCompetitions))
  sports = toSignal(this.store.select(selectSports));
  teams = toSignal(this.store.select(selectTeams))

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.predictionForm = this.fb.group({
      title: ['', Validators.required],
      eventName: ['', Validators.required],
      teamHomeName: ['', Validators.required],
      teamAwayName: ['', Validators.required],
      teamHomeConfidence: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      teamAwayConfidence: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      competition: ['', Validators.required],
      sport: ['', Validators.required],
      eventDate: [null, Validators.required],
      analysisText: ['', Validators.required]
    });
    this.store.select(selectCreateSuccess).subscribe(success => {
      if (success) {
        this.predictionForm.reset();
      }
    });
  }

  onCreate(formData: any): void {
    this.customErrors = {
      dateError: new Date(formData.eventDate) < new Date(),
      isEqualTeams: formData.teamHomeName === formData.teamAwayName
    };
    

    if (  this.customErrors.dateError || this.customErrors.isEqualTeams) return;

    this.store.dispatch(createPrediction({
      "title": formData.title,
      "sport": parseInt(formData.sport),
      "competition": parseInt(formData.competition),
      "team_home": parseInt(formData.teamHomeName),
      "team_away": parseInt(formData.teamAwayName),
      "confidence_team_home": formData.teamHomeConfidence ? parseInt(formData.teamHomeConfidence)/100 : 0,
      "confidence_team_away": formData.teamAwayConfidence ? parseInt(formData.teamAwayConfidence)/100 : 0,
      "event_name": formData.eventName,
      "event_date": formData.eventDate,
      "cote": formData.cote,
      "analysis_text": formData.analysisText,
      "created_by": parseInt(JSON.parse(localStorage.getItem('user') || '{}').user_id),
      "price_jetons": 15
    }))
  }
}
